<script>
import AdminLayout from '@layouts/admin-main'
import { fetchConfig, updateConfig } from '@apis/admin/config'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'
import LangInput from '@components/admin/lang-input'

export default {
  components: { AdminLayout, LangInput },
  data() {
    return {
      config: null,
      loading: false,
      manager: '',
      selected_method: '',
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.selected_method = [
        ...[...this.constants.notification.method].shift(),
      ].shift()
      Promise.all([this.loadConfig()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadConfig() {
      const { config } = await fetchConfig('notification')
      this.config = config
    },
    handleAddManager(method) {
      if (
        method === 'MAIL' &&
        !/^[\w-]+((?:\.|\+|~)[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(this.manager)
      )
        return

      if (this.config.methods[method].manager_events[this.manager]) return

      this.config.methods[method].managers.push(this.manager)
      this.$set(this.config.methods[method].manager_events, this.manager, [])
      this.manager = ''
    },
    handleRemoveManager(method, manager) {
      if (!this.config.methods[method].manager_events[manager]) return

      this.config.methods[method].managers.splice(
        this.config.methods[method].managers.indexOf(manager),
        1
      )
      this.$delete(this.config.methods[method].manager_events, manager, [])
    },
    handleUpdate() {
      this.loading = true
      this.$confirm(this.$t('admin.msg_save'), this.$t('admin.modal_confirm'), {
        type: 'warning',
      })
        .then(() => updateConfig('notification', this.config))
        .then(() => this.loadConfig())
        .then(() =>
          this.$notify({
            title: this.$t('toasted_msg.title'),
            message: this.$t('admin.msg_save_success'),
            type: 'success',
          })
        )
        .catch((e) => (e === 'cancel' ? null : this.$toasted.error(e.message)))
        .finally(() => {
          this.loading = false
        })
    },
    fromPairs,
  },
  page: {
    title: 'Admin::ConfigNotification',
    meta: [{ name: 'description', content: 'Admin::ConfigNotification' }],
  },
}
</script>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>

<template>
  <AdminLayout>
    <div>
      <form
        v-if="config"
        v-loading="loading"
        action="./"
        method="get"
        @submit.prevent="handleUpdate"
      >
        <ul :class="$style.localNavigation">
          <li
            v-for="[method, method_title] in constants.notification.method"
            :key="method"
            :class="{ [$style.on]: selected_method === method }"
          >
            <a href="#" @click.prevent="selected_method = method">{{
              method_title
            }}</a>
          </li>
        </ul>
        <div
          v-for="[method, method_title] in constants.notification.method"
          v-show="selected_method === method"
          :key="method"
        >
          <h3 :class="$style.xeAdmin"
            >{{ method_title }} {{ $t('admin.alert_setting') }}</h3
          >
          <div
            v-for="[event, event_title] in constants.notification.event.filter(
              ([event]) =>
                constants.notification.method_exclude_event[method]
                  .map(([event_name]) => event_name)
                  .indexOf(event) === -1
            )"
            :key="event"
            :class="$style.fl"
            style="width: 50%; height: 400px;"
          >
            <h3 :class="$style.xeAdmin">{{ event_title }}</h3>
            <table :class="$style.rowTable" cellpadding="0">
              <colgroup>
                <col width="50%" />
                <col width="50%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="col" colspan="2"
                    ><div>{{ $t('admin.title') }}</div></th
                  >
                </tr>
                <tr v-if="'subject' in config.methods[method].events[event]">
                  <td colspan="2"
                    ><LangInput
                      v-model="config.methods[method].events[event].subject"
                      :class="$style.fullWidth"
                    ></LangInput
                  ></td>
                </tr>
                <tr>
                  <th scope="col">
                    <div>
                      <label>
                        <input
                          v-model="
                            config.methods[method].events[event].send_user
                          "
                          type="checkbox"
                          true-value="Y"
                          false-value="N"
                        />
                        {{ $t('admin.customer_alert') }}
                      </label>
                    </div>
                  </th>
                  <th scope="col"
                    ><div>{{ $t('admin.admin_alert') }}</div></th
                  >
                </tr>
                <tr>
                  <td
                    ><LangInput
                      v-model="config.methods[method].events[event].content"
                    ></LangInput
                  ></td>
                  <td
                    ><LangInput
                      v-model="
                        config.methods[method].events[event].manager_content
                      "
                    ></LangInput
                  ></td>
                </tr>
                <tr>
                  <th scope="col"
                    ><div>{{ $t('admin.replacer') }}</div></th
                  >
                  <th scope="col"
                    ><div>{{ $t('admin.manager') }}</div></th
                  >
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li
                        v-for="[replacer, replacer_title] in constants
                          .notification.replacers[event]"
                        :key="replacer"
                      >
                        {{ replacer_title }}: {!{{ replacer }}!}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <input
                      v-model="manager"
                      type="text"
                      :class="$style.inputTypeText"
                    />
                    <a
                      href="#"
                      :class="$style.button"
                      @click.prevent="handleAddManager(method)"
                      ><span>{{ $t('admin.add') }}</span></a
                    >
                    <ul>
                      <li
                        v-for="val in config.methods[method].managers"
                        :key="val"
                      >
                        <label>
                          <input
                            v-model="config.methods[method].manager_events[val]"
                            :value="event"
                            type="checkbox"
                          />
                          {{ val }}
                        </label>
                        <i
                          class="el-icon-close"
                          @click="handleRemoveManager(method, val)"
                        ></i>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div :class="$style.buttonArea">
          <span :class="[$style.button, $style.black, $style.large]"
            ><input type="submit" accesskey="s" :value="$t('admin.save')"
          /></span>
        </div>
      </form>
    </div>
  </AdminLayout>
</template>
